module.exports = __webpack_public_path__ + "static/media/Articles 5.977a363c.svg";